import React, { Component, PropTypes } from 'react';
import './Checkbox.css';

const cba = "checkbox__active";
const cbc = "checkbox__check ";
const checkedGreen = '/images/greenCheck.svg';
const checkedNormal = '/images/checked.svg';


class Checkbox extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.getStyleClasses = this.getStyleClasses.bind(this);
  }

	componentWillMount() {
		this.setState({
			checkSrc: this.props.isGreen ? checkedGreen : checkedNormal
		})
	}

  handleChange() {
    const { field, handleClick, index, sidebarIndex } = this.props;
    let val = field.value;
    if (sidebarIndex !== undefined) handleClick(sidebarIndex, !val);
		else if (index !== undefined) handleClick(index, !val[index].value);
		else handleClick(field.name, !val);
  }

	getStyleClasses(value) {
		let extraClass = 'checkbox__wrap ';
		let checkBoxLabelStyle = 'checkbox__label ';
		let checkBoxBorderStyle = 'checkbox__border ';
		if (this.props.isGreen && value === true) {
			checkBoxLabelStyle = 'checkbox__label checkbox__label--green' ;
			checkBoxBorderStyle = 'checkbox__border checkbox__border--green';
		}

		if (this.props.field.extraClass)
			extraClass = extraClass + this.props.field.extraClass;
		return {
			checkBoxLabelStyle,
			checkBoxBorderStyle,
			extraClass
		};
	}


  render() {
    const { field } = this.props;
		let titleText = field.placeholder;
		let value = field.value;
		if (this.props.choice)
			titleText = this.props.choice;

		if (this.props.index !== undefined)
			value = field.value[this.props.index].value;

		let fieldStyles = this.getStyleClasses(value);
    return (
      <div className={fieldStyles.extraClass}>
        <p className={fieldStyles.checkBoxLabelStyle}>
					{titleText}
					<div
						className={fieldStyles.checkBoxBorderStyle}
						onClick={this.handleChange}>
						<img
							src={this.state.checkSrc}
							alt="alt"
							className={value === true ? cbc + cba : cbc} />
					</div>
				</p>
      </div>
    );
  }
}

Checkbox.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired
  }),
  handleClick: PropTypes.func.isRequired,
	choice: PropTypes.string,
	isGreen: PropTypes.bool,
  sidebarIndex: PropTypes.num
};

export default Checkbox;



/** WEBPACK FOOTER **
 ** ./src/components/Checkbox/index.js
 **/